import { Reseller } from 'api/contentful/contentTypes.cloverdotcom';
import { Entry } from 'contentful';
import { parse } from 'qs';
import { setCookie } from 'utils/Cookies';
import { getField, getSys, isEntry } from 'utils/EntryUtil';
import { Environment } from 'utils/Environment';
import { LocalStorage } from 'utils/LocalStorage';

export const TRACKING_HOST_KEY = 'store.trackingHost';
export const REFERRAL_ID_COOKIE_NAME = 'referralId';
export const RESELLER_SYS_ID_KEY = 'resellerSysId';
export const getDefaultPartnerKey = () => (Environment.current.isDev ? 'clover-test' : 'clover.com');

export function getPartnerKey(): string | undefined {
  // this works for the initial renders but then doesn't work once the URL changes
  const basepath = window.location.pathname.split('/')[1];
  if (basepath && basepath !== 'shop' && basepath === 'partner') {
    return window.location.pathname.split('/')[2];
  }

  const params = parse(document.location.search, { ignoreQueryPrefix: true });
  const value = params.partner || params.trackingHost;
  const param = Array.isArray(value) ? value[0] : value;

  if (typeof param === 'string') return param;

  const localStorageTrackingHost = LocalStorage.tryGetItem(TRACKING_HOST_KEY);

  if (localStorageTrackingHost) return localStorageTrackingHost;

  if (params.utm_campaign) {
    return getDefaultPartnerKey();
  }

  return undefined;
}

export const setStorageReseller = (referralId: string, contentfulReseller?: Entry<Reseller>) => {
  if (!isEntry(contentfulReseller)) return;

  const sysId = getSys(contentfulReseller, 'id');
  if (sysId) {
    LocalStorage.trySetItem(RESELLER_SYS_ID_KEY, sysId);
  }

  setCookie(REFERRAL_ID_COOKIE_NAME, referralId);

  const [partnerKey] = getField(contentfulReseller, 'referrerDomains', []);
  if (partnerKey) {
    LocalStorage.trySetItem(TRACKING_HOST_KEY, partnerKey);
  }
};

export const resetReferralHostIdIfDeleted = (
  setReferralHostId: (value: string) => void,
  referralHostId?: string,
) => {
  // If user deletes their Local Storage value, we need to set it back to the default on mount
  if (!referralHostId) {
    setReferralHostId(getDefaultPartnerKey());
  }
};
